var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(243, 146, 0)",
      fillOpacity: 1
    },
    d: "M 18.898438 27.601562 C 18.898438 24.121094 21.179688 21.179688 24.300781 20.160156 L 24.300781 3.421875 C 24.300781 1.859375 23.039062 0.601562 21.480469 0.601562 L 4.320312 0.601562 C 2.761719 0.601562 1.5 1.859375 1.5 3.421875 L 1.5 32.519531 C 1.5 34.140625 2.761719 35.398438 4.320312 35.398438 L 21.421875 35.398438 C 22.140625 35.398438 22.800781 35.101562 23.339844 34.621094 C 20.761719 33.421875 18.898438 30.71875 18.898438 27.601562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 3.300781 32.578125 L 3.300781 3.421875 C 3.300781 1.859375 4.558594 0.601562 6.121094 0.601562 L 4.320312 0.601562 C 2.761719 0.601562 1.5 1.859375 1.5 3.421875 L 1.5 32.519531 C 1.5 34.140625 2.761719 35.398438 4.320312 35.398438 L 6.121094 35.398438 C 4.558594 35.398438 3.300781 34.140625 3.300781 32.578125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,65.882353%,0%)",
      fillOpacity: 1
    },
    d: "M 24.300781 21 L 24.300781 3.421875 C 24.300781 1.859375 23.039062 0.601562 21.480469 0.601562 L 19.679688 0.601562 C 21.238281 0.601562 22.5 1.859375 22.5 3.421875 L 22.5 21 Z M 24.300781 21 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,85.490196%,42.352941%)",
      fillOpacity: 1
    },
    d: "M 34.5 27.601562 C 34.5 31.921875 31.019531 35.398438 26.699219 35.398438 C 22.378906 35.398438 18.898438 31.921875 18.898438 27.601562 C 18.898438 23.28125 22.378906 19.800781 26.699219 19.800781 C 31.019531 19.800781 34.5 23.28125 34.5 27.601562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,67.843137%,33.333333%)",
      fillOpacity: 1
    },
    d: "M 26.699219 19.800781 C 26.398438 19.800781 26.101562 19.800781 25.800781 19.859375 C 29.699219 20.28125 32.699219 23.578125 32.699219 27.601562 C 32.699219 31.621094 29.699219 34.921875 25.800781 35.339844 C 26.101562 35.398438 26.398438 35.398438 26.699219 35.398438 C 31.019531 35.398438 34.5 31.921875 34.5 27.601562 C 34.5 23.28125 31.019531 19.800781 26.699219 19.800781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,80%,0%)",
      fillOpacity: 1
    },
    d: "M 4.5 12.601562 L 21.300781 12.601562 L 21.300781 6 L 4.5 6 Z M 4.5 12.601562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(38.823529%,82.745098%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 5.101562 18 L 8.699219 18 L 8.699219 15 L 5.101562 15 Z M 5.101562 18 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(38.823529%,82.745098%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 11.101562 18 L 14.699219 18 L 14.699219 15 L 11.101562 15 Z M 11.101562 18 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(38.823529%,82.745098%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 17.101562 18 L 20.699219 18 L 20.699219 15 L 17.101562 15 Z M 17.101562 18 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(38.823529%,82.745098%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 5.101562 22.800781 L 8.699219 22.800781 L 8.699219 19.800781 L 5.101562 19.800781 Z M 5.101562 22.800781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(38.823529%,82.745098%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 11.101562 22.800781 L 14.699219 22.800781 L 14.699219 19.800781 L 11.101562 19.800781 Z M 11.101562 22.800781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(38.823529%,82.745098%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 5.101562 27.601562 L 8.699219 27.601562 L 8.699219 24.601562 L 5.101562 24.601562 Z M 5.101562 27.601562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(38.823529%,82.745098%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 11.101562 27.601562 L 14.699219 27.601562 L 14.699219 24.601562 L 11.101562 24.601562 Z M 11.101562 27.601562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(38.823529%,82.745098%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 5.101562 33 L 8.699219 33 L 8.699219 30 L 5.101562 30 Z M 5.101562 33 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(38.823529%,82.745098%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 11.101562 33 L 14.699219 33 L 14.699219 30 L 11.101562 30 Z M 11.101562 33 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(38.823529%,82.745098%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 20.699219 22.621094 L 20.699219 19.800781 L 17.101562 19.800781 L 17.101562 22.800781 L 20.578125 22.800781 C 20.578125 22.738281 20.640625 22.679688 20.699219 22.621094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 21.898438 13.199219 L 3.898438 13.199219 L 3.898438 5.398438 L 21.898438 5.398438 Z M 5.101562 12 L 20.699219 12 L 20.699219 6.601562 L 5.101562 6.601562 Z M 5.101562 12 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 7.5 4.199219 L 3.898438 4.199219 C 3.539062 4.199219 3.300781 3.960938 3.300781 3.601562 C 3.300781 3.238281 3.539062 3 3.898438 3 L 7.5 3 C 7.859375 3 8.101562 3.238281 8.101562 3.601562 C 8.101562 3.960938 7.859375 4.199219 7.5 4.199219 Z M 7.5 4.199219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 9.300781 18.601562 L 4.5 18.601562 L 4.5 14.398438 L 9.300781 14.398438 Z M 5.699219 17.398438 L 8.101562 17.398438 L 8.101562 15.601562 L 5.699219 15.601562 Z M 5.699219 17.398438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 15.300781 18.601562 L 10.5 18.601562 L 10.5 14.398438 L 15.300781 14.398438 Z M 11.699219 17.398438 L 14.101562 17.398438 L 14.101562 15.601562 L 11.699219 15.601562 Z M 11.699219 17.398438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 21.300781 18.601562 L 16.5 18.601562 L 16.5 14.398438 L 21.300781 14.398438 Z M 17.699219 17.398438 L 20.101562 17.398438 L 20.101562 15.601562 L 17.699219 15.601562 Z M 17.699219 17.398438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 9.300781 23.398438 L 4.5 23.398438 L 4.5 19.199219 L 9.300781 19.199219 Z M 5.699219 22.199219 L 8.101562 22.199219 L 8.101562 20.398438 L 5.699219 20.398438 Z M 5.699219 22.199219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 15.300781 23.398438 L 10.5 23.398438 L 10.5 19.199219 L 15.300781 19.199219 Z M 11.699219 22.199219 L 14.101562 22.199219 L 14.101562 20.398438 L 11.699219 20.398438 Z M 11.699219 22.199219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 9.300781 28.199219 L 4.5 28.199219 L 4.5 24 L 9.300781 24 Z M 5.699219 27 L 8.101562 27 L 8.101562 25.199219 L 5.699219 25.199219 Z M 5.699219 27 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 15.300781 28.199219 L 10.5 28.199219 L 10.5 24 L 15.300781 24 Z M 11.699219 27 L 14.101562 27 L 14.101562 25.199219 L 11.699219 25.199219 Z M 11.699219 27 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 9.300781 33.601562 L 4.5 33.601562 L 4.5 29.398438 L 9.300781 29.398438 Z M 5.699219 32.398438 L 8.101562 32.398438 L 8.101562 30.601562 L 5.699219 30.601562 Z M 5.699219 32.398438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 15.300781 33.601562 L 10.5 33.601562 L 10.5 29.398438 L 15.300781 29.398438 Z M 11.699219 32.398438 L 14.101562 32.398438 L 14.101562 30.601562 L 11.699219 30.601562 Z M 11.699219 32.398438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 11.101562 11.398438 C 10.738281 11.398438 10.5 11.160156 10.5 10.800781 L 10.5 7.800781 C 10.5 7.441406 10.738281 7.199219 11.101562 7.199219 C 11.460938 7.199219 11.699219 7.441406 11.699219 7.800781 L 11.699219 10.800781 C 11.699219 11.160156 11.460938 11.398438 11.101562 11.398438 Z M 11.101562 11.398438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 16.5 11.398438 C 16.140625 11.398438 15.898438 11.160156 15.898438 10.800781 L 15.898438 7.800781 C 15.898438 7.441406 16.140625 7.199219 16.5 7.199219 C 16.859375 7.199219 17.101562 7.441406 17.101562 7.800781 L 17.101562 10.800781 C 17.101562 11.160156 16.859375 11.398438 16.5 11.398438 Z M 16.5 11.398438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 18.898438 11.398438 C 18.539062 11.398438 18.300781 11.160156 18.300781 10.800781 L 18.300781 7.800781 C 18.300781 7.441406 18.539062 7.199219 18.898438 7.199219 C 19.261719 7.199219 19.5 7.441406 19.5 7.800781 L 19.5 10.800781 C 19.5 11.160156 19.261719 11.398438 18.898438 11.398438 Z M 18.898438 11.398438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 13.5 11.398438 C 13.320312 11.398438 13.199219 11.339844 13.078125 11.21875 C 12.839844 10.980469 12.839844 10.621094 13.078125 10.378906 L 13.679688 9.78125 C 13.921875 9.539062 14.28125 9.539062 14.519531 9.78125 C 14.761719 10.019531 14.761719 10.378906 14.519531 10.621094 L 13.921875 11.21875 C 13.800781 11.339844 13.679688 11.398438 13.5 11.398438 Z M 13.5 11.398438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 10.5 9 C 10.320312 9 10.199219 8.941406 10.078125 8.820312 C 9.839844 8.578125 9.839844 8.21875 10.078125 7.980469 L 10.679688 7.378906 C 10.921875 7.140625 11.28125 7.140625 11.519531 7.378906 C 11.761719 7.621094 11.761719 7.980469 11.519531 8.21875 L 10.921875 8.820312 C 10.800781 8.941406 10.679688 9 10.5 9 Z M 10.5 9 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 15.898438 9 C 15.71875 9 15.601562 8.941406 15.480469 8.820312 C 15.238281 8.578125 15.238281 8.21875 15.480469 7.980469 L 16.078125 7.378906 C 16.320312 7.140625 16.679688 7.140625 16.921875 7.378906 C 17.160156 7.621094 17.160156 7.980469 16.921875 8.21875 L 16.320312 8.820312 C 16.199219 8.941406 16.078125 9 15.898438 9 Z M 15.898438 9 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 18.300781 9 C 18.121094 9 18 8.941406 17.878906 8.820312 C 17.640625 8.578125 17.640625 8.21875 17.878906 7.980469 L 18.480469 7.378906 C 18.71875 7.140625 19.078125 7.140625 19.320312 7.378906 C 19.558594 7.621094 19.558594 7.980469 19.320312 8.21875 L 18.71875 8.820312 C 18.601562 8.941406 18.480469 9 18.300781 9 Z M 18.300781 9 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 26.699219 32.460938 C 25.019531 32.460938 23.699219 31.140625 23.699219 29.460938 C 23.699219 29.101562 23.941406 28.859375 24.300781 28.859375 C 24.660156 28.859375 24.898438 29.101562 24.898438 29.460938 C 24.898438 30.480469 25.679688 31.261719 26.699219 31.261719 C 27.238281 31.261719 27.71875 31.019531 28.078125 30.601562 C 28.261719 30.421875 28.320312 30.179688 28.261719 29.941406 C 28.261719 29.699219 28.078125 29.460938 27.898438 29.28125 L 24.78125 26.820312 C 24.300781 26.460938 24 25.917969 23.941406 25.320312 C 23.878906 24.71875 24.058594 24.179688 24.421875 23.761719 C 25.019531 23.101562 25.800781 22.679688 26.699219 22.679688 C 28.378906 22.679688 29.699219 24 29.699219 25.679688 C 29.699219 26.039062 29.460938 26.28125 29.101562 26.28125 C 28.738281 26.28125 28.5 26.039062 28.5 25.679688 C 28.5 24.660156 27.71875 23.878906 26.699219 23.878906 C 26.160156 23.878906 25.679688 24.121094 25.320312 24.539062 C 25.140625 24.71875 25.078125 24.960938 25.140625 25.199219 C 25.140625 25.441406 25.320312 25.679688 25.5 25.859375 L 28.621094 28.320312 C 29.101562 28.679688 29.398438 29.21875 29.460938 29.820312 C 29.519531 30.421875 29.339844 30.960938 28.980469 31.378906 C 28.441406 32.101562 27.601562 32.460938 26.699219 32.460938 Z M 26.699219 32.460938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 26.699219 33.601562 C 26.339844 33.601562 26.101562 33.359375 26.101562 33 L 26.101562 22.199219 C 26.101562 21.839844 26.339844 21.601562 26.699219 21.601562 C 27.058594 21.601562 27.300781 21.839844 27.300781 22.199219 L 27.300781 33 C 27.300781 33.359375 27.058594 33.601562 26.699219 33.601562 Z M 26.699219 33.601562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 26.699219 36 C 22.078125 36 18.300781 32.21875 18.300781 27.601562 C 18.300781 22.980469 22.078125 19.199219 26.699219 19.199219 C 31.320312 19.199219 35.101562 22.980469 35.101562 27.601562 C 35.101562 32.21875 31.320312 36 26.699219 36 Z M 26.699219 20.398438 C 22.738281 20.398438 19.5 23.640625 19.5 27.601562 C 19.5 31.558594 22.738281 34.800781 26.699219 34.800781 C 30.660156 34.800781 33.898438 31.558594 33.898438 27.601562 C 33.898438 23.640625 30.660156 20.398438 26.699219 20.398438 Z M 26.699219 20.398438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 21.480469 36 L 4.320312 36 C 2.460938 36 0.898438 34.441406 0.898438 32.578125 L 0.898438 3.421875 C 0.898438 1.558594 2.460938 0 4.320312 0 L 21.421875 0 C 23.339844 0 24.898438 1.558594 24.898438 3.421875 L 24.898438 20.578125 L 24.480469 20.699219 C 21.480469 21.660156 19.5 24.421875 19.5 27.539062 C 19.5 30.300781 21.121094 32.878906 23.640625 34.019531 L 24.421875 34.378906 L 23.761719 34.980469 C 23.160156 35.699219 22.320312 36 21.480469 36 Z M 4.320312 1.199219 C 3.121094 1.199219 2.101562 2.21875 2.101562 3.421875 L 2.101562 32.519531 C 2.101562 33.78125 3.121094 34.800781 4.320312 34.800781 L 21.421875 34.800781 C 21.660156 34.800781 21.898438 34.738281 22.140625 34.679688 C 19.738281 33.121094 18.238281 30.480469 18.238281 27.601562 C 18.238281 24.121094 20.398438 21 23.640625 19.738281 L 23.640625 3.421875 C 23.699219 2.21875 22.679688 1.199219 21.480469 1.199219 Z M 4.320312 1.199219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 20.878906 23.398438 L 16.5 23.398438 L 16.5 19.199219 L 21.300781 19.199219 L 21.300781 22.859375 L 21.179688 23.039062 L 21.121094 23.101562 Z M 17.699219 22.199219 L 20.101562 22.199219 L 20.101562 20.398438 L 17.699219 20.398438 Z M 17.699219 22.199219 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.79e182da34885432dbca1c09852a07c3.svg";
export { ForwardRef as ReactComponent };